import store from '../store'
import {formatTime2} from './index'
// 警告消息处理
export function warnMsg(that, v) {
  console.log('warnMsg*****', that, v)
  let value = 0
  let value2 = 0
  if (v.triggerValue) {
    value = v.triggerValue > 100 ? Math.round(v.triggerValue / 100) : Math.round(v.triggerValue)
    value2 = v.triggerValue > 100 ? (v.triggerValue / 100).toFixed(2) : v.triggerValue.toFixed(2)
  }
  let text = ''
  let title = ''

  if (v.msgType == 1) {
    text = that.$t('warn.event_1_desc')
    text = text.replace('$1', value)
    title = that.$t('warn.event_1')
  }
  if (v.msgType == 2) {
    text = that.$t('warn.event_2_desc')
    title = that.$t('warn.event_2')
  }
  if (v.msgType == 4 || v.msgType == 11 || v.msgType == 12 || v.msgType == 13) {
    if (store.state.getTem == 'F') {
      value = (value * 1.8 + 32).toFixed(0) + ' ℉'
    } else {
      value = value + ' ℃'
    }
    text = that.$t('warn.event_4_desc')
    text = text.replace('$1', value)
    title = that.$t('warn.event_4')
  }
  if (v.msgType == 5) {
    text = that.$t('warn.event_5_desc')
    text = text.replace('$1', value)
    title = that.$t('warn.event_5')
  }
  if (v.msgType == 6) {
    text = that.$t('warn.event_6_desc')
    title = that.$t('warn.event_6')
  }
  if (v.msgType == 7) {
    text = that.$t('warn.event_7_desc')
    text = text.replace('$1', value2)
    title = that.$t('warn.event_7')
  }
  if (v.msgType == 8) {
    if (store.state.getTem == 'F') {
      value = (value * 1.8 + 32).toFixed(0) + ' ℉'
    } else {
      value = value + ' ℃'
    }
    text = that.$t('warn.event_8_desc')
    text = text.replace('$1', value)
    title = that.$t('warn.event_8')
  }
  if (v.msgType == 9) {
    text = that.$t('warn.event_9_desc')
    title = that.$t('warn.event_9')
  }
  if (v.msgType == 10) {
    text = that.$t('warn.event_10_desc')
    text = text.replace('$1', value2)
    title = that.$t('warn.event_10')
  }
  if (v.msgType == 15) { // 半电压不平衡
    text = that.$t('warn.event_15_desc')
    title = that.$t('warn.event_15')
  }
  if (v.msgType == 16) { // 联网异常
    text = that.$t('warn.event_16_desc')
    text = text.replace('$1', value)
    title = that.$t('warn.event_16')
  }
  if (v.msgType == 17) { // 临时充电
    text = that.$t('warn.event_17_desc')
    title = that.$t('warn.event_17')
  }
  // 数据服务剩余一个月
  if (v.msgType == 18) {
    text = that.$t('warn.event_18_desc')
    text = text.replace('$1', formatTime2(v.triggerValue, 'date'))
    title = that.$t('warn.event_18')
  }
  // 数据服务到期
  if (v.msgType == 19) {
    text = that.$t('warn.event_19_desc')
    // text = text.replace('$1', formatTime2(v.triggerValue, 'date'))
    title = that.$t('warn.event_19')
  }
  if (v.msgType == 20) {
    text = that.$t('warn.event_20_desc')
    title = that.$t('warn.event_20')
  }
  if (v.msgType == 21) {
    text = title = that.$t('warn.event_21')
  }
  if (v.msgType == 700) {
    title = that.$t('warn.event_700')
  }
  if (v.msgType == 701) {
    title = that.$t('warn.event_701')
  }
  if (v.msgType == 702) {
    title = that.$t('warn.event_702')
  }
  if (v.msgType == 703) { // 临时充电
    title = that.$t('warn.event_703')
    text = that.$t('warn.event_703_desc')
    // console.log('703', v)
    text = text.replace('$2', $utils.formatTime2(v.triggerSubValue))
    if (v.extendValue) {
      const extend = JSON.parse(v.extendValue)

      text = text.replace('$1', extend.endSoc.toFixed(0))
      text = text.replace('$3', $utils.formatTime2(extend.lastFullChargeTime))
    } else {
      text = text.replace('$1', '--')
      text = text.replace('$2', '--')
    }
  }
  if (v.msgType == 704) {
    title = that.$t('warn.event_704')
    text = that.$t('warn.your') + that.$t('warn.event_704') + that.$t('warn.maint_text')
    // 车辆维护
  }
  if (v.msgType == 705) {
    title = that.$t('warn.event_705')
    // title = '电池维护'
    if (v.triggerValue == 1) {
      text = that.$t('warn.your') + that.$t('warn.event_705') + '-' + that.$t('warn.periodic_maint') + that.$t('warn.maint_text')
    } else {
      text = that.$t('warn.your') + that.$t('warn.event_705') + '-' + that.$t('warn.capacity_maint') + that.$t('warn.maint_text')
    }
  }
  if (v.msgType == 706) {
    title = that.$t('warn.event_706')
    text = that.$t('warn.your') + that.$t('warn.event_706_desc') + '，' + that.$t('warn.maint_text2')
  }
  if (v.msgType == 707) { // 数据服务到期时间少于3个月
    title = that.$t('warn.event_707')
    text = that.$t('warn.event_18_desc')
    text = text.replace('$1', $utils.formatTime2(v.triggerValue, 'date'))
  }
  if (v.msgType == 700 || v.msgType == 701 || v.msgType == 702) {
    if (v.extendValue) {
      const extend = JSON.parse(v.extendValue)
      text = that.$t('warn.StartDischargeMsg')
      text = text.replace('$1', (extend.soc / 100).toFixed(0))
      text = text.replace('$2', (extend.voltageRaw / 100).toFixed(2))
      let tem = Number((extend.batteryTemperature / 100).toFixed(0))
      if (store.state.getTem == 'F') {
        tem = (tem * 1.8 + 32).toFixed(0) + ' ℉'
      } else {
        tem = tem + ' ℃'
      }
      text = text.replace('$3', tem)
    } else {
      text = text.replace('$1', '--')
      text = text.replace('$2', '--')
      text = text.replace('$3', '--')
    }
  }

  // type: 1,警告事件。2，通知事件
  return {
    title,
    text,
    type: v.msgType < 700 ? 1 : 2,
    level: v.level
  }
}
